import { createSelector } from '@reduxjs/toolkit';
import { selectQCTaskState } from './QCTask.slice';
import { selectAuthState } from '../auth/auth.slice';

export const isTaskAssignedToCurrentUserSelect = createSelector(
  [selectQCTaskState, selectAuthState],
  (taskState, authState) =>
    !!taskState.data?.assigneeId &&
    taskState.data?.assigneeId ===
      authState.data?.['dynamika7/user_metadata']?.uuid
);
